import { Component, Input } from "@angular/core";
import { Observable } from "rxjs";
import { PaymentModel } from "src/app/core/models/commerce/payment.model";
import { PaymentListService } from "src/app/core/services/list-services/payment-list.service";
import { BaseListComponent } from "../base-list/base-list.component";
import { DomSanitizer } from "@angular/platform-browser";
import { AuthMyfileService } from "src/app/core/services/auth.myfile.service";
import { OpenModalService } from "src/app/core/services/modal-services/open-modal.service";
import { PdfViewerModalService } from "src/app/core/services/modal-services/pdf-viewer-modal.service";
import { MyfileApiService } from "src/app/core/services/myfile-api.service";
import { ToasterNotificationService } from "src/app/core/services/toaster-notification.service";
import { PaymentType } from "src/app/core/enums/payment-type-enum";
import { PaymentListSortBy } from "src/app/core/enums/sort-by-options/payment-list-sort-enum";
import { TableConfigurationModel } from "src/app/core/models/table/table-configuration.model";
import { ListLayoutExtendableComponent } from "../list-layout/list-layout-extendable/list-layout-extendable.component";
import { ListFilterModel } from "src/app/core/models/table/list-filter.model";
import { TableActionsModel } from "src/app/core/models/table/table-action.model";
import { SortByTypeEnum } from "src/app/core/enums/list-layout/sort-type-enum";
import { EmitSortModel } from "src/app/core/models/table/emit-sort.model";
import { ServiceData } from "src/app/core/models/table/service-data.model";
import { PaymentListConfig } from "./payment-list-config";

@Component({
  selector: 'app-payment-list',
  templateUrl: './payment-list.component.html',
  styleUrls: ['./payment-list.component.scss']
})
export class PaymentListComponent extends ListLayoutExtendableComponent {

  tableConfig: TableConfigurationModel = new TableConfigurationModel();
  serviceData: ServiceData = new ServiceData();

  protected override searchPlaceHolderText: string = $localize`:@@:Search for Finite State Machines by name`;

  override listItemsObservable!: Observable<PaymentModel[]>;

  paymentItem: PaymentModel = new PaymentModel();

  sortBy: PaymentListSortBy = PaymentListSortBy.None;

  //enums used for the HTML references 
  enumPaymentType = PaymentType;
  enumPaymentListSortBy = PaymentListSortBy;

  @Input() public customTable: TableConfigurationModel | undefined = undefined;
  @Input() public sourceId: string | undefined; //is requisitionId usually, businessUnitID for payment for wallets 

  constructor(
    protected paymentListService: PaymentListService,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override myFileApiService: MyfileApiService,
    protected override sanitizer: DomSanitizer,
    protected override pdfModalService: PdfViewerModalService,
    protected override openModalService: OpenModalService,
    protected override authMyFileService: AuthMyfileService,
  ) {
    super(myFileApiService, sanitizer, pdfModalService, authMyFileService, toasterNotificationService, openModalService);
  }

  override rowActionSelected(rowAction: TableActionsModel): void {
    throw new Error("Method not implemented.");
  }
  override buttonActionSelected(buttonAction: any): void {
    throw new Error("Method not implemented.");
  }
  override filterSelected(filterSelected: ListFilterModel): void {
    throw new Error("Method not implemented.");
  }

  ngOnInit(): void {
    if (this.sourceId != undefined) {
      this.paymentListService.sourceId = this.sourceId;

    }
    if (this.customTable != undefined) {
      console.log(12)
      this.tableConfig = this.customTable;
    } else {
      this.tableConfig = new PaymentListConfig();
    }

    this.listItemsObservable = this.paymentListService.resultItems$;
    this.total = this.paymentListService.total$;
    this.isLoading = this.paymentListService.loading$;

    const subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.serviceData.loadingValue = true
      } else {
        this.serviceData.loadingValue = false
      }
    });
    this.unsubscribe.push(subscr);

    const subscr2 = this.listItemsObservable.subscribe(result => {
      this.listItems = Object.assign([], result);
    });
    this.unsubscribe.push(subscr2);

    const subscr3 = this.total.subscribe(result => {
      this.serviceData.totalRecords = this.paymentListService.totalRecords;
      this.serviceData.pageSize = this.paymentListService.pageSize;
      this.serviceData.pageIndex = this.paymentListService.pageIndex;
    });
    this.unsubscribe.push(subscr3);

  }

  ngOnDestroy() {
    this.clearSearch(this.paymentListService);
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }



  sortByPassedSort(passedSortModel: EmitSortModel) {
    if (passedSortModel.sortSelected == SortByTypeEnum.None) {
      this.serviceSort(this.paymentListService, '', '');
    } else {
      this.serviceSort(this.paymentListService, passedSortModel.fieldName, passedSortModel.sortSelected);
    }
  }

  renameType(type: PaymentType): string {
    switch (type) {
      case PaymentType.Credit:
        return $localize`:@@:Credit`;
      case PaymentType.PartialRefund:
        return $localize`:@@:Partial Refund`;
      case PaymentType.Refund:
        return $localize`:@@:Full Refund`;
    }
  }
}
